import { injectDefaults as searcher } from '@/modules/searcher/router';
import { LOGIN_INTERNAL_PAGE_NAME, LOGIN_PAGE_NAME } from '@/modules/authentication/config/login-routes';

const defaults = {
  searcher,
};

export function injectRouteDefaults(location) {
  if (location.name in defaults) {
    return defaults[location.name](location);
  }
  return location;
}

export function isLoginPage(pageName) {
  if (typeof pageName !== 'string') {
    return false;
  }

  return pageName === 'login'
    || pageName === LOGIN_PAGE_NAME
    || pageName === LOGIN_INTERNAL_PAGE_NAME;
}

export default injectRouteDefaults;
